module.exports = __webpack_public_path__ + "img/8.62623fe4.jpg";